module.exports = __webpack_public_path__ + "static/media/add.764100cc.svg";